import {
    ViewMessageSourceDialogueTitleText,
    ViewMessageDetailsDialogueTitleText,
} from './ViewMessageSourceDialog.locstring.json';
import { confirmDialogCloseText } from 'owa-locstrings/lib/strings/confirmdialogclosetext.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { loadMessageDetails } from 'owa-mail-reading-pane-store/lib/services/loadMessageDetails';
import { loadMessageSource } from 'owa-mail-reading-pane-store/lib/services/loadMessageSource';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ClientItem } from 'owa-mail-store';

const classNames = require('classnames');
const styles = require('./ViewMessageSourceDialog.scss');

interface ViewMessageSourceDialogProps {
    onClose: () => void;
}

interface ViewMessageSourceState {
    content: string;
}

@observer
class ViewMessageSourceDialog extends React.Component<
    ViewMessageSourceDialogProps,
    ViewMessageSourceState
> {
    constructor(props: ViewMessageSourceDialogProps) {
        super(props);
        this.state = { content: '' };
    }

    render() {
        return (
            <Dialog
                hidden={false}
                containerClassName={styles.container}
                dialogContentProps={{
                    showCloseButton: false,
                    title: isConsumer()
                        ? loc(ViewMessageSourceDialogueTitleText)
                        : loc(ViewMessageDetailsDialogueTitleText),
                    type: DialogType.normal,
                }}
                onDismiss={this.onDismiss}>
                <div className={classNames(styles.content, 'allowTextSelection')} tabIndex={-1}>
                    {this.state.content}
                </div>
                <DialogFooter>
                    <DefaultButton onClick={this.onDismiss} className={styles.button}>
                        {loc(confirmDialogCloseText)}
                    </DefaultButton>
                </DialogFooter>
            </Dialog>
        );
    }

    public setContent(content: string) {
        this.setState({ content: content });
    }

    private onDismiss = () => {
        this.props.onClose();
    };
}

export async function openMessageSourceDialog(item: ClientItem) {
    const containerDiv = document.createElement('div');
    containerDiv.id = 'ViewMessageSourceDialog';
    document.body.appendChild(containerDiv);

    const dialog = ReactDOM.render(
        React.createElement(ViewMessageSourceDialog, {
            onClose: () => {
                ReactDOM.unmountComponentAtNode(containerDiv);
                document.body.removeChild(containerDiv);
            },
        }),
        containerDiv
    );

    if (isConsumer()) {
        if (item.MimeContent) {
            // If we already have the MimeContent for this item, set its decoded value in the dialog
            dialog.setContent(atob(item.MimeContent.Value));
        } else {
            // Otherwise, load it, set it on the item, and then decode its value for the dialog.
            loadMessageSource(item).then(MimeContent => {
                item.MimeContent = MimeContent;
                dialog.setContent(atob(item.MimeContent.Value));
            });
        }
    } else {
        loadMessageDetails(item).then(content => {
            dialog.setContent(content);
        });
    }
}
